import React from 'react'
import { Link } from 'react-router-dom'
import { TabProps, TabsProps } from '../../types'
import { concatClassName } from '../../utils/helpers'
import './tabs-component.scss'

const Tabs = ({ active, classes, handleChange, children, dataTestId }: TabsProps) => {
  return (
    <>
      <div className={`tabs-container ${concatClassName(classes)}`} data-testid={dataTestId}>
        {children &&
          React.Children.map(children, (child, index) => {
            if (!React.isValidElement<TabProps>(child)) return null
            return (
              <Link
                key={index}
                to={''}
                onClick={(event) => {
                  event.preventDefault()
                  handleChange(index)
                }}
                className={`tab-link ${active === index ? 'activeTab' : ''}`}
              >
                {child.props.title}
              </Link>
            )
          })}
      </div>
      <div className='tab-active-container'>{children[active]}</div>
    </>
  )
}

const Tab = ({ children }: TabProps) => <>{children}</>

export { Tabs, Tab }
